import { KEYWORD_TYPES } from "./keyword";

/**
 * 将 HTML 转为纯文本，供黑词检测接口使用。
 * @param {string} html
 * @returns {string}
 */
export function htmlToPlainText(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.innerText || "";
}

/**
 * 解析 checkContent 接口返回为关键词分组。
 * @param {unknown} payload
 * @returns {{forbid: string[], warn: string[], point: string[], special: string[]}}
 */
export function parseKeywordGroups(payload) {
  const root = payload;
  if (!root || typeof root !== "object") {
    return { forbid: [], warn: [], point: [], special: [] };
  }

  let data = root;
  if (
    root.success === "true" ||
    root.success === true ||
    (root.data && root.data.point) ||
    (root.data && root.data.specialPoint) ||
    (root.data && root.data.special)
  ) {
    data = root.data != null ? root.data : root;
  }
  if (
    data &&
    data.data &&
    (data.success === "true" || data.success === true)
  ) {
    data = data.data;
  }

  return {
    forbid: [],
    warn: [],
    point: Array.isArray(data && data.point) ? data.point : [],
    special: Array.isArray(data && data.specialPoint)
      ? data.specialPoint
      : Array.isArray(data && data.special)
        ? data.special
        : [],
  };
}

/**
 * 预览态关键词 tip（移动端 touch）公共 mixin。
 * 页面需自行实现 applyKeywordHighlightIfNeeded / clearKeywordHighlight。
 */
export default {
  data() {
    return {
      keywordHighlightEnabled: false,
      keywordData: {
        forbid: [],
        warn: [],
        point: [],
        special: [],
      },
      keywordTip: {
        show: false,
        left: 0,
        top: 0,
        groups: [],
      },
    };
  },
  computed: {
    isFromWechat() {
      const from = this.$route.query.from;
      return (
        typeof from === "string" && from.trim().toLowerCase() === "wechat"
      );
    },
    shouldHighlightKeywords() {
      const key = this.$route.query.key;
      const isPreview = typeof key === "string" && key.trim().length > 0;
      return isPreview && this.isFromWechat;
    },
  },
  methods: {
    resetKeywordTipState() {
      this.keywordHighlightEnabled = false;
      this.keywordData = {
        forbid: [],
        warn: [],
        point: [],
        special: [],
      };
      this.keywordTip = { show: false, left: 0, top: 0, groups: [] };
    },
    buildKeywordTipGroups(text, kwTypesAttr) {
      const activeTypes = String(kwTypesAttr || "")
        .split(",")
        .filter(Boolean);
      const groups = [];

      for (let i = 0; i < activeTypes.length; i++) {
        const type = activeTypes[i];
        const config = KEYWORD_TYPES[type];
        const keywords = this.keywordData[type] || [];
        if (!config || !keywords.length) continue;

        const lowerText = text.toLowerCase();
        const matched = keywords.filter((kw) => {
          const lowerKw = String(kw).toLowerCase();
          return lowerKw.includes(lowerText) || lowerText.includes(lowerKw);
        });
        if (!matched.length) continue;

        groups.push({
          type,
          label: config.label,
          keywords: matched,
          bg: config.badgeBg,
          color: config.badgeColor,
        });
      }

      groups.sort(function (a, b) {
        const pb =
          (KEYWORD_TYPES[b.type] && KEYWORD_TYPES[b.type].priority) || 0;
        const pa =
          (KEYWORD_TYPES[a.type] && KEYWORD_TYPES[a.type].priority) || 0;
        return pb - pa;
      });
      return groups;
    },
    findKeywordHighlightEl(target) {
      let el = target;
      while (el && el !== document.body) {
        if (
          el instanceof HTMLElement &&
          el.classList.contains("kw-highlight")
        ) {
          return el;
        }
        el = el.parentNode;
      }
      return null;
    },
    showKeywordTipAt(highlightEl, x, y) {
      if (!this.keywordHighlightEnabled || !highlightEl) return;

      const text = highlightEl.innerText || "";
      const kwTypes = highlightEl.getAttribute("data-kw-types") || "";
      const groups = this.buildKeywordTipGroups(text, kwTypes);
      if (!groups.length) return;

      this.keywordTip = {
        show: true,
        left: x,
        top: y - 30,
        groups,
      };

      this.$nextTick(() => {
        const tipEl = document.getElementById("keyword-tip");
        if (!tipEl) return;
        const { height } = tipEl.getBoundingClientRect();
        let top = y - 30 - height;
        if (top < 8) top = y + 16;
        let left = x;
        const tipWidth = tipEl.offsetWidth || 200;
        if (left + tipWidth > window.innerWidth - 8) {
          left = Math.max(8, window.innerWidth - tipWidth - 8);
        }
        this.keywordTip.left = left;
        this.keywordTip.top = top;
      });
    },
    onKeywordTouchStart(event) {
      if (!this.keywordHighlightEnabled) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      const highlightEl = this.findKeywordHighlightEl(event.target);
      if (highlightEl) {
        this.showKeywordTipAt(highlightEl, touch.clientX, touch.clientY);
        return;
      }
      if (this.keywordTip.show) {
        this.keywordTip.show = false;
      }
    },
  },
  mounted() {
    window.addEventListener("touchstart", this.onKeywordTouchStart, {
      passive: true,
    });
  },
  beforeDestroy() {
    window.removeEventListener("touchstart", this.onKeywordTouchStart);
  },
};
